import * as React from 'react';
import { IDocument } from '../../infrastructure/interfaces';


export const renderPagesCountError = (document: IDocument | null) => {
  if (document == null) {
    return (
      <React.Fragment>
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      <p>Number of pages incorrect.<br />
        Catalog must contain either 4, 8, 12, 16, 18, 20, 22, or any number higher that is divisible by 2. </p>
      <p>Please either: <br />
        Add {document.pages.length <= 16
          ? 4 - (document.pages.length % 4)
          : 2 - (document.pages.length % 2)
        } page(s) {document.pages.length > 4
          ? `or remove ${document.pages.length <= 16
            ? document.pages.length % 4
            : document.pages.length % 2} page(s).`
          : '.'}
      </p>
    </React.Fragment>
  );
};

export const renderDividersError = (pages: string[]) => {
  return (
    <React.Fragment>
      <p>Warning: Divider on Left-hand page (Page {pages.join(',')}).</p>
    </React.Fragment>
  );
};




// WEBPACK FOOTER //
// ./src/components/Warning/DocumentWarning.tsx